import React from 'react'

import { Row, Col, Typography, Card } from 'antd'
import AutoBotPreview from './done-for-you/bot-preview'

const { Title, Paragraph } = Typography

export function WelcomeDoneForYouContent(props) {
  return (
    <div>
      <Row>
        <Col xs={24} className="text-center">
          <Title level={2} style={{ color: '#38b549', marginBottom: 8 }}>
            Welcome to GoHire!
          </Title>
          <Title level={4} style={{ marginTop: 0, fontWeight: 400 }}>
            We're super excited to get you up and running in minutes.
          </Title>
          <Paragraph type="secondary">
            You're just 3 steps away to having a live Apply by Text QR Code and
            Toll Free number.
            <br />
            Answer the questions below, Choose a template, and click next.
          </Paragraph>
        </Col>
      </Row>
      <Row>
        <div className="store-content-wrapper">
          <AutoBotPreview autobotProps={props.autobotProps} />
        </div>
      </Row>
    </div>
  )
}

export function WelcomeContent() {
  return (
    <Row justify="center">
      <Col xs={24} className="text-center">
        <Title level={2} style={{ color: '#38b549', marginBottom: 8 }}>
          Welcome to GoHire!
        </Title>
        <Title level={4} style={{ marginTop: 0, fontWeight: 400 }}>
          Thank you for purchasing our services.
        </Title>
        <Paragraph type="secondary">
          You will need to complete setting up your account before you can
          send messages.
          <br />
          Click next to proceed to setting up your account.
        </Paragraph>
      </Col>
    </Row>
  )
}

export function SetupComplete(props) {
  return (
    <Row justify="center">
      <Col xs={24} className="text-center">
        <Title level={2} style={{ marginBottom: 8 }}>Setup complete!</Title>
        <Paragraph type="secondary">Enjoy using our services.</Paragraph>
        {props.hasQR && (
          <Card style={{ display: 'inline-block', marginTop: 16 }}>
            <img src={props.qrImage} width={400} height={400} alt="Apply-By-Text QR" />
            <Paragraph style={{ marginTop: 12, marginBottom: 0 }}>
              Your Apply-By-Text Bot is ready! Scan the QR Code above to check
              it out.
            </Paragraph>
          </Card>
        )}
      </Col>
    </Row>
  )
}
